import { render } from "./TheHeader.vue?vue&type=template&id=ffb03e9a&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=ffb03e9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ffb03e9a"

export default script